import { useQuery } from '@tanstack/react-query';

import { getPageByUrl } from '@/api/pageMaker';

export const useGetPageByUrl = (url: string) => {
  return useQuery({
    queryKey: ['getPageByIUrl', url],
    queryFn: () => getPageByUrl(url),
    enabled: !!url,
    staleTime: Infinity,
    gcTime: Infinity,
  });
};
